export enum CourseStatus {
  Planned = "planlagt",
  Open = "åpnet",
  Postponed = "utsatt",
  Canceled = "innstilt",
  Deleted = "slettet",
  Closed = "avsluttet",
  TeachingGrantMustBeCalculated = "avsluttet, opplæringstilskuddet må beregnes",
}
